import * as React from 'react';
import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size = 16, ...props }, ref) => (
    <div ref={ref} className={cn('inline-flex items-center justify-center', className)} {...props}>
      <Loader2 className="animate-spin" size={size} aria-hidden />
      <span className="sr-only">Loading</span>
    </div>
  ),
);
Spinner.displayName = 'Spinner';

export { Spinner };
